export const FormFields = {
    EMAIL: 'email',
};
